import { CrafterBreakfastGlobalMenu } from './crafter-breakfast-global-menu-manager.assembly'
import { fetchBreakfastGlobalMenu } from './crafter-breakfast-global-menu-manager.assembly.fetcher'
import { rootMethods } from './root-methods'

export const breakfastGlobalMenu = {
  CrafterBreakfastGlobalMenu,
  fetchBreakfastGlobalMenu,
  rootMethods
}